__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-budget-manage/').replace(/[/]{3,}/g, "/");